import cn from 'classnames';
import { isValidElement } from 'react';
import { LayoutContainer } from '@petsmart-ui/sparky';
import type { ContainerProps } from './types';
import './Container.scss';

export function Container({ items, topOfPage }: ContainerProps) {
    return (
        <LayoutContainer
            className={cn('contentful-container', {
                'contentful-container__br-all': !topOfPage,
            })}
        >
            {items?.filter(isValidElement)}
        </LayoutContainer>
    );
}
